import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastService } from './services/toast.service';
import { IToast } from './interfaces/toast.interface';

@Component({
  selector: 'lib-toasts',
  imports: [NgbToastModule, NgTemplateOutlet, TranslatePipe],
  host: {
    class: 'toast-container position-fixed top-0 end-0 p-3',
    style: 'z-index: 1200',
  },
  templateUrl: './toasts.html',
  styleUrl: './toasts.scss',
})
export class Toasts {
  protected readonly toastService = inject(ToastService);

  protected closeToast(toast: IToast) {
    this.toastService.remove(toast);
  }
}
